<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-shtax-400 hover:text-shtax-600" :href="route('bank_statements')">Wyciągi</inertia-link>
      <span class="text-shtax-400 font-medium">/</span> Nowy wyciąg
    </h1>
    <div class="bg-white rounded-md shadow overflow-hidden md:overflow-visible max-w-3xl">
      <form @submit.prevent="store" class="z-0">
        <div class="p-8 -mr-6 -mb-8 flex flex-wrap">

            <file-input v-model="form.file" :errors="[form.errors.file]" class="pr-6 pb-8 w-full" type="file" accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/csv,text/comma-separated-values" label="Plik wyciągu (XLS, XLSX, CSV)" />

            <text-area-input class="pr-6 pb-8 w-full" v-model:checked="form.description" :error="form.errors.description" label="Opis"  />

        </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex justify-end items-center rounded-b-md" v-if="$page.props.can['add bank statement']">
          <loading-button :loading="form.processing" class="btn-shtax" type="submit">Dodaj wyciąg</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextAreaInput from '@/ShtaxComponents/TextAreaInput'
import FileInput from '@/ShtaxComponents/FileInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  metaInfo: { title: 'Nowy wyciąg' },
  components: {
    LoadingButton,
    TextAreaInput,
    FileInput
  },
  layout: Layout,
  props: {
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        description: null,
        file: null
      }),
    }
  },
  methods: {
    store() {
      this.form.post('/bank_statements/store')
    },
  }
}
</script>
